module.exports = __webpack_public_path__ + "static/img/4.cdc0786.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/4.png
// module id = 5FKT
// module chunks = 0